import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async create(data) {
    return await axiosIns.post(obtenerUrlAPIPagos('configuraciones'), data);
  },
  async findAll(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('configuraciones'), { params: opciones.params });
  },
  async findByUniversidadId(universidadId) {
    return await axiosIns.get(obtenerUrlAPIPagos(`configuraciones/universidades/${universidadId}`));
  },
  async update(id, data) {
    return await axiosIns.patch(obtenerUrlAPIPagos(`configuraciones/${id}`), data);
  },
};
